// extracted by mini-css-extract-plugin
module.exports = {"videoIframe":"Video_videoIframe__h86BJ"};